import { render, staticRenderFns } from "./TendersComponent.vue?vue&type=template&id=948f7d9a"
import script from "./TendersComponent.vue?vue&type=script&lang=js"
export * from "./TendersComponent.vue?vue&type=script&lang=js"
import style0 from "./TendersComponent.vue?vue&type=style&index=0&id=948f7d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports